export * from './equipments-edit.component';
